export default __webpack_public_path__ + "static/media/uploadIconBlack.f3090d70.svg";